<template>
  <div class="smart-lead-detail">
    <div class="smart-lead-close-container">
      <button
        type="button"
        @click="toggleServiceBottomSheet(false)"
      >
        <img
          src="../../../assets/img/service/X.svg"
          alt="Edit"
          class="smart-lead-close-icon"
        >
      </button>
      <div class="smart-lead-close">
        Close
      </div>
    </div>
    <fragment v-if="!loadingDetail">
      <SmartLeadCard
        isDetailView
        :serviceItem="smartLead"
      />
      <div class="grid-column auto gap-32 margin-top-48">
        <LeadDetail />
        <ServiceNotes
          :serviceItem="smartLead"
        />
      </div>
      <ServiceItems />
    </fragment>
    <div v-else class="loading-container">
      <img
        src="../../../assets/img/general/loading-white.svg"
        class="img-size-24"
        alt="Edit"
      >
    </div>
  </div>
</template>
<script>
import SmartLeadCard from '@shared/components/service/SmartLeadCard.vue';
import serviceMixin from '@shared/mixins/serviceMixin';
import ServiceItems from '../shared/ServiceItems.vue';
import LeadDetail from '../leadDetail/LeadDetail.vue';
import ServiceNotes from '../shared/ServiceNotes.vue';

export default {
  name: 'SmartLeadDetail',
  components: {
    ServiceItems,
    SmartLeadCard,
    LeadDetail,
    ServiceNotes,
  },
  mixins: [serviceMixin],
  props: {
    smartLead: Object,
    close: Function,
  },
  mounted() {
    this.getDetail();
    this.getComfortCreditBalance();
  },
  methods: {
    async getDetail() {
      this.$store.dispatch('getLeadDetail', { noticeId: this.smartLead.id });
    },
    getComfortCreditBalance() {
      if (this.smartLead.customerId) {
        this.$store.dispatch('getComfortCreditBalance', this.smartLead.customerId);
      }
    }
  },
};
</script>
<style lang="scss">

.smart-lead-detail {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  scrollbar-width: none;
  padding: 0 0 100px 0;
  ::-webkit-scrollbar {
    display: none;
  }
  .ac-overlay {
    border-radius: 12px;
  }
  .smart-lead-close-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0;
    .smart-lead-close-icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .smart-lead-close{
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      text-align: right;
      color: $WHITE;
    }
  }
}
</style>
